import { FormGroup } from "@angular/forms";
import { Component, OnInit } from "@angular/core";
import { Validators, FormBuilder } from "@angular/forms";
import { TranslateService } from "@ngx-translate/core";
import { MatSnackBar } from "@angular/material/snack-bar";
import { EmbryoService } from "src/app/Services/Embryo.service";
import { LoginUsersService } from "src/app/Services/login-users.service";
import { AccountSettingService } from "src/app/Services/account-setting.service";
import { StaticPagesService } from "src/app/Services/static-pages.service";
import { MarketingService } from "src/app/Services/marketing.service";
import Swal from "sweetalert2";
import { LatLngLiteral } from "@agm/core";
import { Router } from "@angular/router";

@Component({
    selector: "app-add-address-page",
    templateUrl: "./add-address-page.component.html",
    styleUrls: ["./add-address-page.component.scss"],
})
export class AddAddressPageComponent implements OnInit {
    addAddressForm: FormGroup = new FormGroup({});
    loadingSpinner: boolean = false;
    addressSubmitted = false;
    cities: any = [];
    user: any;
    areaList: any = [];
    districts: any = [];
    filteredAreaList: any;
    lang: any;
    lat = 30.033333;
    lng = 31.233334;
    address: any;
    isGuest: boolean = false;
    environmentVariables: any;
    addressNames: any[] = [
        { id: 0, name: "Home", name_ar: "المنزل" },
        { id: 1, name: "Work", name_ar: "العمل" },
        { id: 2, name: "Others", name_ar: "أخرى" },
    ];
    loading: boolean = true;
    address_obj: any;
    cordnates: any = {
        lat_marker: null,
        lng_marker: null,
    };

    constructor(
        private formBuilder: FormBuilder,
        private auth: LoginUsersService,
        public snackBar: MatSnackBar,
        public embryoService: EmbryoService,
        private accountSettingService: AccountSettingService,
        private translate: TranslateService,
        private confgServ: StaticPagesService,
        private marketingService: MarketingService,
        private router : Router
    ) {
        embryoService.emitLang.subscribe((lang: string) => {
            translate.setDefaultLang(lang);
            this.lang = lang;
        });
    }

    ngOnInit() {
        this.getInitilizingData();
        this.isGuest = this.auth.isGuest();
        this.setCurrentPosition();
        this.lang = localStorage.getItem("lang");
        this.translate.setDefaultLang(this.lang);
        this.typeAddressCheck();
        this.addAddressForm.controls.name.setValue("Home");
    }

    centerChanged(coords: LatLngLiteral) {
        this.cordnates.lat_marker = coords.lat;
        this.cordnates.lng_marker = coords.lng;
    }

    public markerDragEnd(event: any) {
        this.lat = event.coords.lat;
        this.lng = event.coords.lng;
    }

    typeAddressCheck() {
        this.getCities();
        if (!this.address) {
            this.addAddressForm = this.formBuilder.group({
                name: [
                    this.addressNames[0].name,
                    this.environmentVariables?.ADDRESS_NAME_CONFIG ===
                    "show-required"
                        ? [Validators.required]
                        : [],
                ],
                city_id: ["", Validators.required],
                area_id: ["", Validators.required],
                district_id: [
                    "",
                    this.environmentVariables?.ENABLE_DISTRICT
                        ? [Validators.required]
                        : [],
                ],
                address: [
                    "",
                    this.environmentVariables?.ADDRESS_STREET_CONFIG ===
                    "show-required"
                        ? [Validators.required]
                        : [],
                ],
                apartment: [
                    "",
                    this.environmentVariables?.ADDRESS_APT_CONFIG ===
                    "show-required"
                        ? [Validators.required]
                        : [],
                ],
                building: [
                    "",
                    this.environmentVariables?.ADDRESS_BUILDING_CONFIG ===
                    "show-required"
                        ? [Validators.required]
                        : [],
                ],
                floor: [
                    "",
                    this.environmentVariables?.ADDRESS_FLOOR_CONFIG ===
                    "show-required"
                        ? [Validators.required]
                        : [],
                ],
                landmark: [
                    "",
                    this.environmentVariables?.ADDRESS_LANDMARK_CONFIG ===
                    "show-required"
                        ? [Validators.required]
                        : [],
                ],
                shop_name: [
                    this.address?.shop_name,
                    this.environmentVariables?.ADDRESS_SHOP_NAME_CONFIG ===
                    "show-required"
                        ? [Validators.required]
                        : [],
                ],
                     commercial_record: [
                    this.address?.commercial_record,
                    this.environmentVariables?.ADDRESS_COMMERCIAL_RECORD_CONFIG ===
                    "show-required"
                        ? [Validators.required]
                        : [],
                ],
                bank_account: [
                    this.address?.bank_account,
                    this.environmentVariables?.ADDRESS_BANK_ACCOUNT_CONFIG ===
                    "show-required"
                        ? [Validators.required]
                        : [],
                ],
                contact_number: [
                    this.address?.contact_number,
                    this.environmentVariables?.ADDRESS_CONTACT_NUMBER_CONFIG ===
                    "show-required"
                        ? [Validators.required]
                        : [],
                ],
                shop_image: [
                    this.address?.shop_image,
                    this.environmentVariables?.ADDRESS_SHOP_IMAGE_CONFIG ===
                    "show-required"
                        ? [Validators.required]
                        : [],
                ],
                      attachment_2: [
                    this.address?.attachment_2,
                    this.environmentVariables?.ADDRESS_ATTACHMENT_2_CONFIG ===
                    "show-required"
                        ? [Validators.required]
                        : [],
                ],
                attachment_3: [
                    this.address?.attachment_3,
                    this.environmentVariables?.ADDRESS_ATTACHMENT_3_CONFIG ===
                    "show-required"
                        ? [Validators.required]
                        : [],
                ],
                primary: [""],
            });
        }
        else {
            this.addAddressForm = this.formBuilder.group({
                name: [
                    this.address?.name,
                    this.environmentVariables?.ADDRESS_NAME_CONFIG ===
                    "show-required"
                        ? [Validators.required]
                        : [],
                ],
                city_id: [this.address?.city_id, Validators.required],
                area_id: [this.address?.area_id, Validators.required],
                district_id: [
                    this.address.district_id ? this.address.district_id : "",
                ],
                address: [
                    this.address?.address,
                    this.environmentVariables?.ADDRESS_STREET_CONFIG ===
                    "show-required"
                        ? [Validators.required]
                        : [],
                ],
                apartment: [
                    this.address?.apartment,
                    this.environmentVariables?.ADDRESS_APT_CONFIG ===
                    "show-required"
                        ? [Validators.required]
                        : [],
                ],

                building: [
                    this.address && this.address.building
                        ? this.address.building
                        : "",
                    this.environmentVariables?.ADDRESS_BUILDING_CONFIG ===
                    "show-required"
                        ? [Validators.required]
                        : [],
                ],
                floor: [
                    this.address?.floor,
                    this.environmentVariables?.ADDRESS_FLOOR_CONFIG ===
                    "show-required"
                        ? [Validators.required]
                        : [],
                ],
                landmark: [
                    this.address?.landmark,
                    this.environmentVariables?.ADDRESS_LANDMARK_CONFIG ===
                    "show-required"
                        ? [Validators.required]
                        : [],
                ],
                shop_name: [
                    this.address?.shop_name,
                    this.environmentVariables?.ADDRESS_SHOP_NAME_CONFIG ===
                    "show-required"
                        ? [Validators.required]
                        : [],
                ],
                                     commercial_record: [
                    this.address?.commercial_record,
                    this.environmentVariables?.ADDRESS_COMMERCIAL_RECORD_CONFIG ===
                    "show-required"
                        ? [Validators.required]
                        : [],
                ],
                bank_account: [
                    this.address?.bank_account,
                    this.environmentVariables?.ADDRESS_BANK_ACCOUNT_CONFIG ===
                    "show-required"
                        ? [Validators.required]
                        : [],
                ],
                contact_number: [
                    this.address?.contact_number,
                    this.environmentVariables?.ADDRESS_CONTACT_NUMBER_CONFIG ===
                    "show-required"
                        ? [Validators.required]
                        : [],
                ],
                shop_image: [
                    this.address?.shop_image,
                    this.environmentVariables?.ADDRESS_SHOP_IMAGE_CONFIG ===
                    "show-required"
                        ? [Validators.required]
                        : [],
                ],
                      attachment_2: [
                    this.address?.attachment_2,
                    this.environmentVariables?.ADDRESS_ATTACHMENT_2_CONFIG ===
                    "show-required"
                        ? [Validators.required]
                        : [],
                ],
                attachment_3: [
                    this.address?.attachment_3,
                    this.environmentVariables?.ADDRESS_ATTACHMENT_3_CONFIG ===
                    "show-required"
                        ? [Validators.required]
                        : [],
                ],
                primary: [this.address?.primary],
            });

            this.lat = parseFloat(this.address?.lat);
            this.lng = parseFloat(this.address?.lng);
        }
        this.getCities();
    }

    uploadedImageUrl(image: any, formName?: string) {
        if(formName){
            this.addAddressForm.controls[formName].setValue(image);
        }
    }

    setAddress(addressObj: any) {
        this.address_obj = addressObj;
        if (addressObj?.code == 200 && addressObj?.data?.address) {
            this.addAddressForm.controls.address.setValue(
                addressObj?.data?.address
            );
            this.addAddressForm.controls.address.updateValueAndValidity();
        }
        if (
            addressObj?.code == 200 &&
            addressObj?.data?.city_id &&
            addressObj?.data?.inventory?.pivot?.area_id
        ) {
            this.addAddressForm.controls.city_id.setValue(
                addressObj?.data?.city_id
            );
            this.addAddressForm.controls.area_id.setValue(
                addressObj?.data?.inventory?.pivot?.area_id
            );
            this.lat = parseFloat(addressObj?.cordnates?.lat_marker);
            this.lng = parseFloat(addressObj?.cordnates?.lng_marker);
            this.getArea(addressObj?.data?.city_id);
            if (this.environmentVariables?.ENABLE_DISTRICT) {
                this.getDistrict(addressObj?.data?.inventory?.pivot?.area_id);
            }
        } else {
            this.addAddressForm.controls.city_id.setValue(null);
            this.addAddressForm.controls.area_id.setValue(null);
        }
        this.addAddressForm.controls.city_id.updateValueAndValidity();
        this.addAddressForm.controls.area_id.updateValueAndValidity();
    }

    getInitilizingData() {
        this.confgServ.getenvConfig().subscribe((res) => {
            this.environmentVariables = res;
            this.lat = res?.GOOGLE_MAP_LATITUDE;
            this.lng = res?.GOOGLE_MAP_LONGITUDE;
        });
    }

    getCities() {
        this.accountSettingService.getCities().subscribe({
            next: (response: any) => {
                if (response.code === 200) {
                    this.cities = response.data;
                    if (this.address) {
                        this.getArea(this.address?.city_id);
                        this.getDistrict(this.address?.area?.id);
                    }
                    this.loading = false;
                }
            },
        });
    }
    
    getDistrictV2(e: any) {
        this.districts = [];
        this.resetDistrict();
        this.getDistrict(e);
    }

    getDistrict(area: any) {
        const index = this.areaList.findIndex(
            (item: any) => item.id == (area.value || area)
        );
        if (index !== -1) {
            if (this.areaList[index].districts.length) {
                this.districts = this.areaList[index].districts;
            } else {
                this.districts.length = 1;
                this.districts[0] = this.areaList[index];
            }
        }
        setTimeout(() => {
            if (this.districts.length == 0) {
                this.addAddressForm.controls["district_id"].clearValidators();
            } else if (this.environmentVariables?.ENABLE_DISTRICT) {
                this.addAddressForm.controls["district_id"].setValidators([
                    Validators.required,
                ]);
            }
            this.addAddressForm.controls[
                "district_id"
            ].updateValueAndValidity();
        }, 200);
    }

    onaddAddressFormFormSubmit(): void {
        this.addressSubmitted = true;
        if (this.addAddressForm.invalid) {
            if (
                !this.addAddressForm?.value.area_id &&
                this.environmentVariables?.SHOW_ADDRESS_MAP &&
                this.environmentVariables?.ENABLE_PROFILE_SET_AREA_FROM_MAP &&
                this.address_obj?.code == 422
            ) {
                Swal.fire({
                    html: `<p style='color:white'>${this.address_obj.message}</p>`,
                    width: 250,
                    position: "bottom-end",
                    background: "#bd362f",
                    timerProgressBar: true,
                    showConfirmButton: false,
                    timer: 3000,
                    backdrop: false,
                    allowOutsideClick: true,
                });
            }
            this.addAddressForm.markAllAsTouched();
            return;
        }
        this.loadingSpinner = true;
        const data = this.addAddressForm.value;
        // data.lat = this.lat;
        // data.lng = this.lng;
        data.lat = this.cordnates?.lat_marker
            ? this.cordnates?.lat_marker
            : this.lat; // this.lat;
        data.lng = this.cordnates?.lng_marker
            ? this.cordnates?.lng_marker
            : this.lng; // this.lng;
        if (data.district_id == data.area_id) {
            data.district_id = null;
        }
        if (data.city_id == data.area_id) {
            data.area_id = null;
        }
        this.accountSettingService
            .addAddress(data)
            .subscribe((response: any) => {
                if (response.code === 200) {
                    this.marketingService.fbTracking("track", "AddNewAddress");
                    this.addAddressForm.reset();
                    this.auth.setUser(response.data);
                    this.auth.setUserDataEmit(response.data);
                    this.user = this.auth.getUser();
                    this.router.navigate(["/"]);
                    // this.dialogAddAddress.close(response.data);
                    this.router.navigate(["/"]);
                    localStorage.setItem(
                        "auth_user_crocs",
                        JSON.stringify(response.data)
                    );
                } else {
                    Swal.fire({
                        html: `<p style='color:white'>${response.message}</p>`,
                        width: 250,
                        position: "bottom-end",
                        background: "#bd362f",
                        timerProgressBar: true,
                        showConfirmButton: false,
                        timer: 3000,
                        backdrop: false,
                        allowOutsideClick: true,
                    });
                    // this.toastrService.error(response.message, "", {
                    //     positionClass: "toast-bottom-right",
                    // });
                }
                this.loadingSpinner = false;
            });
    }

    onEditAddressFormFormSubmit(): void {
        this.addressSubmitted = true;
        if (this.addAddressForm.invalid) {
            if (
                !this.addAddressForm?.value.area_id &&
                this.environmentVariables?.SHOW_ADDRESS_MAP &&
                this.environmentVariables?.ENABLE_PROFILE_SET_AREA_FROM_MAP &&
                this.address_obj?.code == 422
            ) {
                Swal.fire({
                    html: `<p style='color:white'>${this.address_obj.message}</p>`,
                    width: 250,
                    position: "bottom-end",
                    background: "#bd362f",
                    timerProgressBar: true,
                    showConfirmButton: false,
                    timer: 3000,
                    backdrop: false,
                    allowOutsideClick: true,
                });
            }
            this.addAddressForm.markAllAsTouched();
            return;
        }

        this.loadingSpinner = true;
        const data = this.addAddressForm.value;
        data.lat = this.cordnates?.lat_marker
            ? this.cordnates?.lat_marker
            : this.lat; // this.lat;
        data.lng = this.cordnates?.lng_marker
            ? this.cordnates?.lng_marker
            : this.lng; // this.lng;
        
        if (data.district_id == data.area_id) {
            data.district_id = null;
        }

        if (data.city_id == data.area_id) {
            data.area_id = null;
        }

        this.accountSettingService
            .editAddress(data, this.address.id)
            .subscribe((response: any) => {
                if (response.code === 200) {
                    this.marketingService.fbTracking("track", "AddNewAddress");
                    this.addAddressForm.reset();
                    this.auth.setUser(response.data);
                    this.auth.setUserDataEmit(response.data);
                    this.user = this.auth.getUser();
                    this.router.navigate(["/"]);
                } else {
                    Swal.fire({
                        html: `<p style='color:white'>${response.message}</p>`,
                        width: 250,
                        position: "bottom-end",
                        background: "#bd362f",
                        timerProgressBar: true,
                        showConfirmButton: false,
                        timer: 3000,
                        backdrop: false,
                        allowOutsideClick: true,
                    });
                }
                this.loadingSpinner = false;
            });
    }

    selectAddressType() {
        let addressGroup = <FormGroup>this.addAddressForm.controls["address"];
        if (addressGroup.controls["address_type"].value == 1) {
            addressGroup.controls["name"].clearValidators();
            addressGroup.controls["CustomerFirstName"].clearValidators();
            addressGroup.controls["CustomerLastName"].clearValidators();
            addressGroup.controls["phone"].clearValidators();
            addressGroup.controls["city_id"].clearValidators();
            addressGroup.controls["area_id"].clearValidators();
            addressGroup.controls["district_id"].clearValidators();
            addressGroup.controls["address"].clearValidators();
            addressGroup.controls["apartment"].clearValidators();
            addressGroup.controls["landmark"].clearValidators();
            addressGroup.controls["floor"].clearValidators();
            addressGroup.controls["primary"].clearValidators();
            addressGroup.controls["address_id"].setValidators([
                Validators.required,
            ]);
        } else if (this.user.is_affiliate) {
            addressGroup.controls["name"].clearValidators();
            addressGroup.controls["CustomerFirstName"].setValidators([
                Validators.required,
            ]);
            addressGroup.controls["CustomerLastName"].setValidators([
                Validators.required,
            ]);
            addressGroup.controls["phone"].setValidators([Validators.required]);
        } else if (!this.user.is_affiliate) {
            addressGroup.controls["name"].setValidators([Validators.required]);
            addressGroup.controls["CustomerFirstName"].clearValidators();
            addressGroup.controls["CustomerLastName"].clearValidators();
            addressGroup.controls["phone"].clearValidators();
        } else if (this.isGuest) {
            addressGroup.controls["name"].clearValidators();
            addressGroup.controls["address_type"].clearValidators();
            addressGroup.controls["address_type"].setValue(null);
            addressGroup.controls["address_id"].clearValidators();
            addressGroup.controls["CustomerFirstName"].setValidators([
                Validators.required,
            ]);
            addressGroup.controls["CustomerLastName"].setValidators([
                Validators.required,
            ]);
            addressGroup.controls["phone"].setValidators([Validators.required]);
        } else {
            addressGroup.controls["city_id"].setValidators([
                Validators.required,
            ]);
            addressGroup.controls["area_id"].setValidators([
                Validators.required,
            ]);
            addressGroup.controls["address"].setValidators([
                Validators.required,
            ]);
            addressGroup.controls["apartment"].setValidators([
                Validators.required,
            ]);
            addressGroup.controls["floor"].setValidators(
                this.environmentVariables?.SHOW_ADDRESS_FLOOR
                    ? [Validators.required]
                    : []
            );
        }

        addressGroup.controls["name"].updateValueAndValidity();
        addressGroup.controls["CustomerFirstName"].updateValueAndValidity();
        addressGroup.controls["CustomerLastName"].updateValueAndValidity();
        addressGroup.controls["phone"].updateValueAndValidity();
        addressGroup.controls["phone"].updateValueAndValidity();
        addressGroup.controls["floor"].updateValueAndValidity();
        addressGroup.controls["city_id"].updateValueAndValidity();
        addressGroup.controls["area_id"].updateValueAndValidity();
        addressGroup.controls["address"].updateValueAndValidity();
        addressGroup.controls["apartment"].updateValueAndValidity();
        addressGroup.controls["landmark"].updateValueAndValidity();
        addressGroup.controls["primary"].updateValueAndValidity();
        addressGroup.controls["address_id"].updateValueAndValidity();
    }

    resetArea() {
        this.addAddressForm.controls.area_id.setValue(null);
        this.addAddressForm.controls.area_id.updateValueAndValidity();
        this.districts = [];
        this.resetDistrict();
    }

    resetDistrict() {
        this.addAddressForm.controls.district_id.setValue(null);
        this.addAddressForm.controls.district_id.updateValueAndValidity();
    }

    public getArea(area: any) {
        const index = this.cities.findIndex((item: any) => item.id == area);
        if (index !== -1) {
            if (this.cities[index].areas.length) {
                this.areaList = this.cities[index].areas;
            }
            else {
                this.areaList = [];
                this.areaList.push(this.cities[index]);
                this.addAddressForm
                    .get("address.area_id")
                    ?.setValue(this.cities[index].id);
                this.districts.push(this.cities[index]);
            }
        }
        this.filteredAreaList = this.areaList;
    }

    public setCurrentPosition() {
        if ("geolocation" in navigator) {
            navigator.geolocation.getCurrentPosition(
                (position) => {
                    this.lat = this.address?.lat
                        ? this.address?.lat
                        : position.coords.latitude
                        ? position.coords.latitude
                        : this.environmentVariables?.GOOGLE_MAP_LATITUDE;
                    this.lng = this.address?.lng
                        ? this.address?.lng
                        : position.coords.longitude
                        ? position.coords.longitude
                        : this.environmentVariables?.GOOGLE_MAP_LONGITUDE;
                },
                (err) => {
                    if (this.address) {
                        this.lat = this.address?.lat;
                        this.lng = this.address?.lng;
                    } else {
                        this.lat = parseFloat(
                            this.environmentVariables?.GOOGLE_MAP_LATITUDE
                        );
                        this.lng = parseFloat(
                            this.environmentVariables?.GOOGLE_MAP_LONGITUDE
                        );
                    }
                }
            );
        }
        else {
            this.lat = this.address?.lat
                ? this.address?.lat
                : this.environmentVariables?.GOOGLE_MAP_LATITUDE;
            this.lng = this.address?.lng
                ? this.address?.lng
                : this.environmentVariables?.GOOGLE_MAP_LONGITUDE;
        }
    }
}
